import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "antd";
export default ({ icon, content, pathname, isDrawer }) => (
  <Link to={pathname} style={{ display: "flex", alignItems: "center" }}>
    <Icon
      type={icon}
      style={{ fontSize: "2.5rem", color: isDrawer ? "white" : null }}
    />
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 2rem",
        color: isDrawer ? "white" : null
      }}
    >
      {content}
    </div>
  </Link>
);



// WEBPACK FOOTER //
// ./src/Components/Navigation/ItemMenu.js